import type { ListTrendingVideosRequest } from './types';

export const TRENDING_VIDEO_QUERY_KEYS = {
  default: () => ['trendingVideos'] as const,
  list: (params?: ListTrendingVideosRequest) => [...TRENDING_VIDEO_QUERY_KEYS.default(), 'list', params] as const,
  detail: (videoId: string) => [...TRENDING_VIDEO_QUERY_KEYS.default(), 'detail', videoId] as const,
};
